import { Flex, Text } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/react'
import { Info } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { Size } from '~/types/ThemeTypes'

import { useCallInProgressModalStyle } from './componentStyles/CallInProgressModal.style'

export const CallInProgressModal = () => {
  const { t } = useTranslation()
  const {
    callInProgressModal: [modalState, setModalState],
  } = useModalState()

  const handleClose = () => {
    setModalState({ open: false })
  }

  const styles = useCallInProgressModalStyle()

  return (
    <MangoModal
      open={modalState.open}
      onOpenChange={(details) => {
        if (!details.open) handleClose()
      }}
      closeButton={false}
      ariaLabel={t('callInProgressModal.title')}
      size={Size.sm}
      body={
        <Flex css={styles.bodyContainer}>
          <Icon css={styles.icon}>
            <Info size="100%" />
          </Icon>
          <Text css={styles.headerText}>{t('callInProgressModal.title')}</Text>
          <Text css={styles.bodyText}>{t('callInProgressModal.message')}</Text>
        </Flex>
      }
      footer={
        <Flex css={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            {t('callInProgressModal.dismiss')}
          </MangoButton>
        </Flex>
      }
    />
  )
}
